const UPGRADE_REQUESTED = 'Announcement Text: Upgrade Requested';

const announcementTextAnalyticsConstants = {
  UPGRADE_REQUESTED,
};

export default announcementTextAnalyticsConstants;
